import PhotoGalleryCarousel from './photo-gallery-carousel';

const photoGalleryCarouselConfig = {
  name: 'photoGalleryCarousel',
  class: PhotoGalleryCarousel,
  querySelector: {
    articleContent: '.article-list__content',
    enlargedGroup: '.article-list-carousel__article-thumb-enlarged-group',
    interstitialAd: '.ad-unit--gallery-interstitial',
    adCloseButton: '.ad-unit--gallery-interstitial .ad-unit__close-button',
  },
  options: {
    adLockClass: 'photo-gallery-carousel--ad-locked',
    slickEnlarged: {
      appendArrows: '.slick-slide .article-list__article-image-wrapper', // eslint-disable-line max-len
      asNavFor: '.photo-gallery-carousel .sync-thumbs',
      mobileFirst: true,
      adaptiveHeight: true,
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
    },
    slickThumbs: {
      asNavFor: '.photo-gallery-carousel .sync-viewport',
      mobileFirst: true,
      adaptiveHeight: true,
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 8,
          },
        },
      ],
    },
  },
};

export default photoGalleryCarouselConfig;
